// height of middle content section when card is collapsed
export var DEFAULT_COLLAPSED_HEIGHT = 360;
// how tall a post has to be before it allows skipping
export var POST_HEIGHT_TO_SHOW_SCROLL_TO_NEXT = 2000;
// puts the scroll past the siteheader + previous post margin-bottom
export var HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING = 64;
// px from post content top needed to be scrolled before 'next post' is shown
export var PX_SCROLLED_BEFORE_SHOWING_SCROLL_TO_NEXT = 900;
// resolution of cover image to grab from cdn
export var DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH = 1000;
export var DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT = 300;
//# sourceMappingURL=constants.js.map